import React, { useEffect } from 'react';
import PageWrapper from '../../components/ui/layout/PageWrapper';
import Panel from '../../components/ui/panel/Panel';
import Text from '../../components/ui/text/Text';
import { Row, Col } from 'react-grid-system';
import Input from '../../components/ui/input/Input';
import Button from '../../components/ui/button/Button';
import FormGroup from '../../components/ui/form-group/FormGroup';
import FormLabel from '../../components/ui/form-label/FormLabel';
import { connect } from 'react-redux';
import { AppState } from '../..';
import { IIntercomReducer } from '../../reducers/intercomReducer';
import './Intercom.scss';
import { setIntercomField, resetIntercomState, fetchIntercomSettings, updateIntercomSettings } from '../../actions/intercomActions';
import counterpart from 'counterpart';

interface IIntercom {
  intercomReducer: IIntercomReducer,
  dispatch: Function
}

const Intercom: React.FC<IIntercom> = ({ intercomReducer, dispatch }) => {
  const { name, adminId, isUpdatingSettingsRequest } = intercomReducer;
  const adminIdTooLong = adminId.length > 8;

  useEffect(() => {
    dispatch(fetchIntercomSettings());
    return function () {
      dispatch(resetIntercomState());
    }
  }, []);

  const onSubmit = (evt: any) => {
    evt.preventDefault();
    dispatch(updateIntercomSettings({ crmAdminId: Number(adminId), crmAdminName: name }))
  }

  return (
    <PageWrapper className="intercom">
      <form onSubmit={onSubmit}>
        <Panel title="INTERCOM_HEADING_TITLE">
          <Text content="INTERCOM_HEADING_CONTENT" noMargin />
        </Panel>
        <Panel title="INTERCOM_INITIATED_MESSAGES_HEADING">
          <FormGroup>
            <Row align="center">
              <Col xs={1}>
                <FormLabel target="intercom-initiated-messages-name" content="INTERCOM_INITIATED_MESSAGES_NAME" noMargin />
              </Col>
              <Col xs={11}>
                <Input
                  id="intercom-initiated-messages-name"
                  value={name}
                  onChange={(evt: any) => dispatch(setIntercomField("name", evt.target.value))}
                  required
                />
              </Col>
            </Row>
          </FormGroup>

          <Row align="center">
            <Col xs={1}>
              <FormLabel target="intercom-initiated-messages-name" content="INTERCOM_INITIATED_MESSAGES_ADMIN_ID" noMargin />
            </Col>
            <Col xs={11}>
              <Input
                id="intercom-initiated-messages-name"
                type="number"
                value={adminId}
                isError={adminIdTooLong}
                errorMsg={counterpart("INTERCOM_INITIATED_MESSAGES_ADMIN_ID_ERROR")}
                onChange={(evt: any) => dispatch(setIntercomField("adminId", evt.target.value))}
                required
              />
            </Col>
          </Row>
        </Panel>

        <Button
          id="intercom-save-changes"
          title="INTERCOM_INITIATED_MESSAGES_SAVE"
          type="submit"
          disabled={adminIdTooLong}
          isLoading={isUpdatingSettingsRequest}
          isFullWidth
        />
      </form>
    </PageWrapper>
  )
}

export default connect((state: AppState) => ({ intercomReducer: state.intercom }))(Intercom);